function updateLine(transcript, startTime, text) {
  return transcript.map((line) => {
    if (line.start === startTime) {
      return {
        ...line,
        speaker: text,
      };
    }
    return line;
  });
}

/**
 * Updating speaker for transcript
 * @param {Object} assets,
 * @param {Object} payload,
 * @param {string} payload.assetId
 * @param {string} payload.revisionId
 * @param {string} payload.startTime
 * @param {string} payload.newSpeaker
 * @param {string} payload.oldSpeaker
 * @returns {Array}
 */
export default function updateTranscriptSpeaker(assets, payload) {
  const {
    assetId, revisionId, startTime, newSpeaker, oldSpeaker,
  } = payload;

  const updatedAssets = assets.map((asset) => {
    if (asset._id === assetId) {
      const updatedTranscripts = asset.transcripts.map((currentTranscript) => {
        if (currentTranscript.revisionId === revisionId) {
          if (startTime) {
            const updatedTranscript = updateLine(currentTranscript.transcript, startTime, newSpeaker);
            return {
              ...currentTranscript,
              transcript: updatedTranscript,
            };
          }
          const updatedTranscript = currentTranscript.transcript.map((item) => (item.speaker === oldSpeaker ? { ...item, speaker: newSpeaker } : item));

          return {
            ...currentTranscript,
            transcript: updatedTranscript,
          };
        }
        return currentTranscript;
      });
      return {
        ...asset,
        transcripts: updatedTranscripts,
      };
    }
    return asset;
  });

  return updatedAssets;
}
